/**
 * Mighty45 semantic color system (JS version for client-console).
 * Mirrors coach-console NewColors.ts.
 */
const NewColors = {
  white: "#fff",
  black: "#000",
  brand: {
    primary: "#3B82F6",
    secondary: "#EA580C",
    accent: "#D97706",
  },
  triadicPower: {
    primary: "#2E5266",
    primaryDark: "#1E3A47",
    accent: "#FF7A5A",
    powerAccent: "#B91C1C",
    secondaryStart: "#FF7A5A",
    secondaryEnd: "#B91C1C",
    buttons: {
      primary: "#2E5266",
      primaryHover: "#1E3A47",
      cta: "#FF7A5A",
      ctaHover: "#E56B4A",
      urgent: "#B91C1C",
      urgentHover: "#9F1616",
    },
  },
  status: {
    success: "#059669",
    warning: "#F7B801",
    error: "#DC5A47",
    info: "#0EA5E9",
  },
  pageBackground: "#F3F4F8",
  cardBackground: "#FFFFFF",
  sectionBackground: "#F9FAFB",
  text: {
    primary: "#1F2937",
    secondary: "#6B7280",
    tertiary: "#9CA3AF",
    muted: "#9CA3AF",
    inverse: "#FFFFFF",
  },
  nutrition: {
    calories: "#1E40AF",
    caloriesBackground: "#DBEAFE",
    proteins: "#EA580C",
    proteinsBackground: "#FED7AA",
    carbs: "#D97706",
    carbsBackground: "#FED7AA",
    fats: "#7C3AED",
    fatsBackground: "#E9D5FF",
  },
  getActiveScheme(scheme = "triadicPower") {
    if (scheme === "triadicPower") {
      return {
        primary: this.triadicPower.primary,
        secondary: this.triadicPower.accent,
        accent: this.triadicPower.powerAccent,
        primaryButton: this.triadicPower.buttons.primary,
        primaryButtonHover: this.triadicPower.buttons.primaryHover,
        secondaryButton: this.triadicPower.buttons.cta,
        secondaryButtonHover: this.triadicPower.buttons.ctaHover,
      };
    }
    return {
      primary: this.brand.primary,
      secondary: this.brand.secondary,
      accent: this.brand.accent,
      primaryButton: this.status.error,
      secondaryButton: this.brand.secondary,
    };
  },
  get active() {
    return this.getActiveScheme("triadicPower");
  },
};

export default NewColors;
